export const CustomSearch = (data, searchByName, val, status, closedStatus) => {
  let searchName = '';
  let arrayValue = '';
  const str = 'installment';

  const response = data?.filter((item) => {
    if (val === 'name') {
      if (location?.pathname?.toLowerCase().includes(str?.toLowerCase())) {
        searchName = item?.loan?.Employees?.name?.split(' ');
        arrayValue = item?.loan?.Employees?.name;
      } else {
        searchName = item?.name
          ? item?.name?.split(' ')
          : item?.Employee?.name
          ? item?.Employee?.name?.split(' ')
          : item?.Employees?.name?.split(' ');
        arrayValue = item?.name ? item?.name : item?.Employee?.name ? item?.Employee?.name : item?.Employees?.name;
      }
    } else if (val === 'pm') {
      searchName = item?.projectManager?.split(' ');
      arrayValue = item?.projectManager;
    }
    if (!searchName) return false;
    const arr = [searchName[1], searchName[2]];

    const joinString = arr?.join(' ');
    if (status && status === closedStatus) {
      return arrayValue && arrayValue?.toLowerCase()?.includes(searchByName?.toLowerCase()) && item.status === closedStatus;
    } else {
      return (
        (arrayValue && searchName[0] && searchName[0]?.toLowerCase()?.startsWith(searchByName?.toLowerCase()?.trim())) ||
        (searchName[1] && searchName[1]?.toLowerCase()?.startsWith(searchByName?.toLowerCase()?.trim())) ||
        (searchName[2] && searchName[2]?.toLowerCase()?.startsWith(searchByName?.toLowerCase()?.trim())) ||
        (searchName[1] && searchName[2] && joinString?.toLowerCase()?.startsWith(searchByName?.toLowerCase()?.trim())) ||
        arrayValue?.toLowerCase()?.startsWith(searchByName?.toLowerCase()?.trim())
      );
    }
  });

  return response;
};
